import { useTranslation } from 'react-i18next'

import { FieldRow, FieldSkeleton, FieldsTable, FieldViewValue } from '@/components/layout/field-row'
import { TabCard } from '@/components/layout/tab-card'

const ROW_LABEL_KEYS = [
  'organisation:places.pms.connected.provider',
  'organisation:places.pms.connected.company',
  'organisation:places.pms.connected.property',
] as const

// Note: whether the building is connected is not known yet, so this shows the connected layout;
// title and labels are real, only the values are skeletons
export const PmsTabSkeleton = () => {
  const { t } = useTranslation(['organisation'])

  return (
    <TabCard title={t('organisation:places.integrations.pms.title')}>
      <FieldsTable aria-hidden>
        {ROW_LABEL_KEYS.map((labelKey) => (
          <FieldRow key={labelKey} label={t(labelKey)}>
            <FieldViewValue>
              <FieldSkeleton height="1.6rem" width="20rem" />
            </FieldViewValue>
          </FieldRow>
        ))}
      </FieldsTable>
    </TabCard>
  )
}
